module.exports = __webpack_public_path__ + "static/media/idg.12d317d9.png";